import Vector3 from './Vector3'
import ColorUtility from '@/util/ColorUtility'
export default class Tag
{
    tagid = -1;
    type = '';
	name = '';
	filtered = false;
	color = { r: 0, g: 0, b: 0 };

	/** 
     * Count of Timelines of which the Tag is a member.
     * Maintained only by the frontend via the addTimelineTag and removeTimelineTag mutations.
     * */
    timelineCount: number = 0;

	public constructor(tagid : number = -1, name : string = '', type = 'category', color : any = null)
	{
		this.tagid = tagid;
		this.name = name;
		this.type = type;
		if (color != null)
		{
			this.color.r = color.r;
			this.color.g = color.g;
			this.color.b = color.b;
		}
		else
		{
			this.color = Tag.defaultColor(tagid);
		}
	}

	public static defaultColor(tagid: number) : any
	{
		console.log('defaultColor');
		const colors = [
			ColorUtility.red1,    ColorUtility.green1,  ColorUtility.yellow1,
			ColorUtility.blue1,   ColorUtility.teal1,   ColorUtility.orange1,
			ColorUtility.purple1, ColorUtility.red2,    ColorUtility.green2,
			ColorUtility.yellow2, ColorUtility.blue2,   ColorUtility.purple2,
			ColorUtility.red3,    ColorUtility.green3,  ColorUtility.yellow3,
			ColorUtility.blue3,   ColorUtility.purple3, ColorUtility.blue4
		];
		const startingColor = colors[Math.max(0, tagid % colors.length)];
		return {
			r: Math.round(255 * startingColor.x),
		  	g: Math.round(255 * startingColor.y),
			b: Math.round(255 * startingColor.z)
		};
	}
}